const translations = {
    downloadShapeFile: 'Download SHP'
};

export default translations;
